import React from 'react';
import TituloPisoCaucho from '../components/sections/PisoDeCaucho/TituloPisoCaucho';
import IntroPisoCaucho from '../components/sections/PisoDeCaucho/IntroPisoCaucho';
import FabricadoPisoCaucho from '../components/sections/PisoDeCaucho/FabricadoPisoCaucho';
import CaracteristicasPisoCaucho from '../components/sections/PisoDeCaucho/CaracteristicasPisoCaucho'; 
import CatalogoPisoCaucho from '../components/sections/PisoDeCaucho/CatalogoPisoCaucho';
import FormularioContactoCaucho from '../components/sections/PisoDeCaucho/FormularioContactoCaucho';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const PisoDeCauchoPage = () => {
  return (
    <div>
      <Header />

        <TituloPisoCaucho /> 
        <IntroPisoCaucho /> 
        <CaracteristicasPisoCaucho /> 
        <CatalogoPisoCaucho />
        <FabricadoPisoCaucho />  
        <FormularioContactoCaucho />
        
      <Footer />
    </div>
  );
};

export default PisoDeCauchoPage;